﻿﻿import { ClosedLoopAssignType } from '../enums/index';

export interface IClosedLoopAssignRequest {
    type: ClosedLoopAssignType;
    registrationId: number;
    donorId: number;
    donorShieldDirectId: number;
    watrRequestId: number;
    followUpDonorId: number;
}
